import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import MenuList from "./MenuList";

const MenuDesktop = ({ children }) => {
  return (
    <Flex>
      <Box
        bg="menu.800"
        color="menu.100"
        w={"11rem"}
        height="100vh"
        p="0.75rem"
        position="fixed"
        overflowY="scroll"
        css={{
          "&::-webkit-scrollbar": {
            width: "6px",
            backgroundColor: "#F5F5F5",
          },
          "&::-webkit-scrollbar-track": {
            webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.3)",
            backgroundColor: "var(--chakra-colors-menu-800)",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#909ea6",
          },
        }}
      >
        <Box></Box>
        <MenuList></MenuList>
      </Box>
      <Box w="100%" ml={"11rem"}>
        {children}
      </Box>
    </Flex>
  );
};

export default MenuDesktop;
